export default "__VITE_ASSET__BZJTwAsd__"